module.exports = __webpack_public_path__ + "img/pricing-light.639a98cd.png";